import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UIState, Notification } from '../../types/types';

const initialState: UIState = {
  isMenuOpen: false,
  theme: 'light',
  sidebarOpen: false,
  notifications: [],
  isAuthModalOpen: false,
  authModalMode: 'login',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleMenu: (state) => {
      state.isMenuOpen = !state.isMenuOpen;
    },
    closeMenu: (state) => {
      state.isMenuOpen = false;
    },
    openMenu: (state) => {
      state.isMenuOpen = true;
    },
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    closeSidebar: (state) => {
      state.sidebarOpen = false;
    },
    addNotification: (state, action: PayloadAction<Notification>) => {
      state.notifications.push(action.payload);
    },
    removeNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter(
        (notification) => notification.id !== action.payload
      );
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    openAuthModal: (state, action: PayloadAction<'login' | 'signup'>) => {
      state.isAuthModalOpen = true;
      state.authModalMode = action.payload;
    },
    closeAuthModal: (state) => {
      state.isAuthModalOpen = false;
    },
  },
});

export const {
  toggleMenu,
  closeMenu,
  openMenu,
  toggleTheme,
  setTheme,
  toggleSidebar,
  closeSidebar,
  addNotification,
  removeNotification,
  clearNotifications,
  openAuthModal,
  closeAuthModal,
} = uiSlice.actions;

export default uiSlice.reducer; 